import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import SubmissionDetails from "./SubmissionDetails";
import SubmissionHeader from "./SubmissionHeader";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import FurtherInformation from "./FurtherInformation";
import Page500 from "../../../pages/auth/Page500";
import {
  loadSubmissionAsync,
  selectSubmission,
} from "../../../redux/slices/submission";

const Submission = () => {
  const [loading, setLoading] = useState(false);
  const [loadingSubmissionId, setLoadingLiceneActionId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const SubmissionSelector = useAppSelector(selectSubmission);

  const dispatch = useAppDispatch();

  let { profileNo, submissionId } = useParams();
  if (!profileNo || !submissionId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingSubmissionId !== submissionId) {
    setLoadingLiceneActionId(submissionId);
    dispatch(loadSubmissionAsync(submissionId));
    return <Loading />;
  }

  const submissionDetails = SubmissionSelector.submission;

  if (!submissionDetails) {
    return <Loading />;
  }

  if (!submissionDetails.response.ok) {
    if (submissionDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <SubmissionHeader submissionDetails={submissionDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <SubmissionDetails submissionDetails={submissionDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <FurtherInformation
            submissionDetails={submissionDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        submissionDetails={submissionDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-versions"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default Submission;
